import React, { useState, useEffect } from "react";
import { Button, Col, Form, Input, Row, Select, message, notification } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { vendorService, countryService } from "../../../services";
import MaterialLikeSelect from "../../../components/MaterialLikeSelect";
import MaterialLikeInput from "../../../components/MaterialLikeInput";
import { changeDocumentTitle } from "../../../utils/title";

function VendorForm() {
  const { id } = useParams();
  const navigate = useNavigate()
  const [form] = Form.useForm();
  const isEditMode = id !== undefined;
  const [loading, setLoading] = useState(false);
  const [vendorCategory, setVendorCategory] = useState([]);
  const [country, setcountry] = useState([]);

  const getVendorCategories = async () => {
    try {
      const { success, data } = await vendorService.fetchCategories();
      if (success) {
        setVendorCategory(data);
      } else {
        console.error("Failed to fetch vendor categories", data);
      }
    } catch (error) {
      console.error("Error fetching vendor categories:", error);
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const data = { ...values };
      const response = isEditMode ? await vendorService.updateVendor(id, data) : await vendorService.addVendor(data);
      setLoading(false);

      if (response.success) {
        notification.success({ message: "Success", description: isEditMode ? "Vendor updated successfully!" : "Vendor added successfully", placement: "topRight" });
        navigate(`/operations/vendor`)
      } else {
        const errors = response.data?.errors || [response.message];
        notification.error({
          message: "Error",
          description: `Error: ${errors.join(", ")}`,
          placement: "topRight",
        });
      }
    } catch (err) {
      console.error("Update Error", err);
    }
  };

  const initialize = async () => {
    const response = await countryService.countryGet();
    if (response?.success) {
      setcountry(response.data);
    }
    if (isEditMode) {
      const hide = message.loading("Fetching Data...", 0)
      const response = await vendorService.viewVendor(id);
      hide()
      if (response?.success) {
        form.setFieldsValue({
          ...response?.data,
          vendors_categorys: response.data.vendors_categorys_id,
        });
      } else {
        console.error(`Error fetching vendor: ${response?.message || "Unknown error"}`);
      }
    }

  };

  useEffect(() => {
    changeDocumentTitle(isEditMode ? " Edit Vendor" : " Add Vendor");
    initialize();
    getVendorCategories();
  }, []);

  return (
    <div
      style={{
        padding: "15px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Row gutter={26} style={{ marginBottom: 10, padding: "5px" }}>
        <Col span={12}>
          <h1 style={{ fontWeight: "bold" }}>
            {" "}
            {isEditMode ? "Edit Vendor" : "Add Vendors"}
          </h1>
        </Col>
      </Row>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ layout: "vertical" }}
      >
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item
              name="vendors_categorys"
              rules={[{ required: true, message: "Please select a vendor category!" }]}
            >
              <MaterialLikeSelect
                label="Vendor Category"
                required
                value={form.getFieldValue("vendors_categorys")}
                onChange={(value) => form.setFieldValue('vendors_categorys', value)}
                options={vendorCategory.map((category) => ({
                  id: category.id,
                  value: category.id,
                  label: category.name,
                }))}
              />
              {/* <Select placeholder="Select a vendor category">
                {vendorCategory.map((category) => (
                  <Select.Option key={category.id} value={category.id}>
                    {category.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="name" rules={[{ required: true, message: "Please input name!" }]}>
              <MaterialLikeInput
                label="Name"
                required
                value={form.getFieldValue("name")}
                onChange={(e) => form.setFieldValue("name", e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="email"
              rules={[
                { required: true, message: "Please input email!" },
                {
                  type: "email",
                  message: "Please enter a valid email!",
                },
              ]}
            >
              <MaterialLikeInput
                label="Email"
                required
                value={form.getFieldValue("email")}
                onChange={(e) => form.setFieldValue("email", e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="phone" rules={[{ required: true, message: "Please input phone!" }]}>
              <MaterialLikeInput
                label="Phone"
                required
                value={form.getFieldValue("phone")}
                onChange={(e) => form.setFieldValue("phone", e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="town">
              <MaterialLikeInput
                label="Town"
                value={form.getFieldValue("town")}
                onChange={(e) => form.setFieldValue("town", e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="address">
              <MaterialLikeInput
                label="Address"
                value={form.getFieldValue("address")}
                onChange={(e) => form.setFieldValue("address", e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="city">
              <MaterialLikeInput
                label="City"
                value={form.getFieldValue("city")}
                onChange={(e) => form.setFieldValue("city", e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="country">
              <MaterialLikeSelect
                label="Country"
                value={form.getFieldValue("country")}
                onChange={(value) => form.setFieldValue('country', value)}
                options={country.map((count) => ({
                  id: count.id,
                  value: count.iso_code,
                  label: count.name,
                }))}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item style={{ textAlign: "center", marginTop: 30 }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "50%" }}
                loading={loading}
              >
                {" "}
                {isEditMode ? "Update Vendor" : "Add Vendor"}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default VendorForm;
